import React, { useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore } from '@/common/dependencies';
import Markdown from '../markdown';
import Anchor from './Anchor';
import HtmlCard from '../html-card';
import { memo } from 'react';
import { useEffect } from 'react';

const ItemMarkdown = observer((props) => {
  const {
    typing,
    text,
    codeInfo,
    isCompleted,
    messageId,
  } = props;

  // html 预览消息
  if(codeInfo?.title){
    const markdownList = text.split('```');
    if(markdownList.length <= 3){
      return (
        <>
          {
            markdownList.map((item, index) => {
              const isLast = markdownList.length - 1 == index;

              if(/^html/i.test(item)){
                return (
                  <HtmlCard 
                    key="html-card" 
                    codeInfo={codeInfo} 
                    htmlCode={item.replace(/^html\s*/, '')} 
                    messageId={messageId}
                    />
                )
              }
              return (
                <Markdown
                  key={`markdown_${index}`}
                  typing={typing && isLast}
                  text={item + (isLast ? '' : '\n')}
                  codeInfo={codeInfo}
                  components={{
                    a: _props => (
                      <Anchor
                        {..._props}
                        tooltipable={isCompleted}
                        references={props}
                      />
                    ),
                  }}
                />
              )
            })
          }
        </>
      )
    }
  }

  return (
    <Markdown
      typing={typing}
      text={text}
      codeInfo={codeInfo}
      components={{
        a: _props => (
          <Anchor
            {..._props}
            tooltipable={isCompleted}
            references={props}
          />
        ),
      }}
    />
  )
});
export default (ItemMarkdown);